import EA from '../helpers/init';

export default EA.Methods.headerDropdownHandler = ($this) => {
    const wrappers = $this.querySelectorAll('.sub-menu-wrapper');
    const topLevelDropdowns = $this.querySelectorAll('.menu > .menu-item-has-children');

    if(topLevelDropdowns.length === 0) return;

    topLevelDropdowns.forEach((item) => {
        const arrowButton = item.querySelector('.submenu-toggle');
        const navLink = item.querySelector('.nav-link');

        navLink.addEventListener('mouseover', () => {
            item.classList.add('open');
        });

        document.querySelector('.header').addEventListener('mouseleave', () => {
            item.classList.remove('open');
        });

        arrowButton.addEventListener('click', () => {
            item.classList.toggle('open');
        });
    });

    if (wrappers.length === 0) return;

    const showPanel = (panelId, panels, categoryBtns) => {
        panels.forEach((p) => { 
            p.hidden = (p.id !== panelId);
            setTimeout(() => {
                p.classList.toggle('active', p.id === panelId);
            }, 50);
        });

        categoryBtns.forEach((btn) => {
            const li = btn.closest('.category-item');
            if (li) li.classList.toggle('active', btn.dataset.panel === panelId);
        });
    };

    wrappers.forEach((wrapper) => {
        const panels = [...wrapper.querySelectorAll('.sub-menu-panel')];
        const categoryBtns = [...wrapper.querySelectorAll('.category-btn')];

        const firstCategoryBtn = categoryBtns[0];

        if (firstCategoryBtn) {
            const firstPanelId = firstCategoryBtn.dataset.panel;
            const firstPanelExists = panels.some((panel) => panel.id === firstPanelId);

            if(firstPanelId && firstPanelExists) {
                showPanel(firstPanelId, panels, categoryBtns);
            }
        }

        ['click', 'mouseover'].forEach((event) => {
            wrapper.addEventListener(event, (e) => {
                const btn = e.target.closest('.category-btn');
                if (!btn) return;
    
                const panelId = btn.dataset.panel;
                if (!panelId) return;
    
                const panelExists = panels.some((p) => p.id === panelId);
                if (!panelExists) return;
    
                showPanel(panelId, panels, categoryBtns);
            });
        });
    });

};
